module.exports = __webpack_public_path__ + "img/OpcioB_600x600.3daab419.gif";